export const SBP_REST = process.env.SBP_REST
export const SBP_TABLE = process.env.SBP_TABLE
export const SERVICE_FEE_PERCENTS = 3.5
export const SERVICE_FEE_PERCENTS_CHOCOLATE = 3
export const SERVICE_FEE_PERCENTS_PIVALDI = 5
export const SERVICE_FEE_MAX = 200
export const SERVICE_FEE_MAX_OLD = 199

export const RESTAURANTS_FOR_SERVICE_FEE_MODAL = [
  'vernadka-1680',
  'pivaldi-odincovo-925',
  'kvartal-green-garden-1185',
  'nalubaloo',
  'hinkalnaya-kaco-3164',
  'restoran-na-krishe-1799',
  'acha-chacha-pyatnickaya-254',
  'gastrobar-iskra-1997',
  'acha-chacha',
  'van-gogh-1800',
  'kimchi-3145',
  'joy-2464',
  'pazza-pizza-1694',
  'deribas-435',
  'for-people-2369',
  'one-special-3095',
  'tomorrow-1077',
  'joki-686',
  'kafe-fonoteca-256',
  'gastromarket-preobraghenskii-1651',
  'miragrill-1366',
  'laffa-laffa-bronnaya-4-509',
  'biblioteka-novoorlovskaya-2219',
  'il-cantuccio-2757',
  'poklonka-bar-3148',
  'nido-bistro-1526',
  'chaihana64-3055',
  'noriko-1139',
  'foster-cinema-3232',
  'vartaziya-3114',
  'neapol-i-bristol-1685',
  'mario-village-1589',
  'butcher-and-banker-3352',
  'rossich-805',
  'restoran-jamamai-3245',
  'frends-762',
  'mano-a-mano-819',
  'che-harcho-2857',
  'sam-prishel-2955',
  'fox-3297',
  'testrkeeper'
]

export const SERVICE_FEE_TEXT = [
  'the-bik-957',
  'the-bik-nametkina-12a-986',
  'the-bik-strastnoi-bulvar-3235',
  'the-bik-1527',
  'the-bik-1533',
  'vernadka-1680',
  'the-bik-amin-2308',
  'the-bik-2596',
  'the-bik-strastnoi-bulvar-3235_tmp',
  'the-bik-4284',
  'office'
]
